<template>
   <iframe src="https://cdn.lightwidget.com/widgets/3e4241f3b5c25eb89fd9328061d9c463.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>
</template>

<script>
export default {
  name: 'instagram-display',
};
</script>


// WEBPACK FOOTER //
// src/components/InstagramDisplay.vue